import { Component, Input } from '@angular/core';
import { ComponentWithCopy } from '../../intefaces/interfaces';
import { HeadlineLarge } from '../../components/typography/headline-large/headline-large';
import { BodyLarge } from '../../components/typography/body-large/body-large';

@Component({
  selector: 'app-logo-cloud-colored-bg',
  imports: [HeadlineLarge, BodyLarge],
  templateUrl: './logo-cloud-colored-bg.html',
  styleUrl: './logo-cloud-colored-bg.css'
})
export class LogoCloudColoredBg {
   @Input() content!: ComponentWithCopy
}
